import React, { useEffect, useRef, useState, type PropsWithChildren } from 'react'

export interface NodeProviderProps {
  nodeMap: Map<Node, (rootNode: Node | undefined) => void>
}

// 兼容通过DOM方法添加的节点
export function NodeProvider(props: PropsWithChildren<NodeProviderProps>) {
  const anchorRef = useRef<HTMLDivElement>(null)
  const [nodeMap] = useState(props.nodeMap)
  useEffect(() => {
    if (window.__POWERED_BY_QIANKUN__) {
      const shadowroot = anchorRef.current?.getRootNode()

      // 恢复内外部节点, re-render 时触发
      for (const [, restore] of nodeMap) {
        restore(shadowroot)
      }

      const nodeHandler = (node: Node, next: () => void, { isIconfont }: Record<string, boolean>) => {
        // 内外部都需要的节点
        if (isIconfont) {
          nodeMap.set(node, (rootNode) => {
            // 在原本地方添加(也就是主系统)
            next()
            // 在子系统内部添加节点
            rootNode?.appendChild(node.cloneNode(true))
          })
          nodeMap.get(node)?.(shadowroot)
          return
        }
        // 非内外部都需要的节点, 只在子系统内部添加节点
        nodeMap.set(node, (rootNode) => {
          rootNode?.appendChild(node)
        })
        nodeMap.get(node)?.(shadowroot)
      }

      window['custom-append-child'].reinstall()
      window['custom-document-write'].reinstall()
      window.delayedEventBus.on('custom-append-child', nodeHandler)

      return () => {
        window['custom-append-child'].cleanup()
        window['custom-document-write'].cleanup()
        window.delayedEventBus.off('custom-append-child', nodeHandler)
      }
    }
    return
  }, [nodeMap])
  return (
    <>
      {props.children}
      <div ref={anchorRef} />
    </>
  )
}
